/** @format — Shipments empty states (list empty + no selection panel) */

import IllustrationEmptyState from "@/components/ui/IllustrationEmptyState";

type ShipmentsEmptyStateProps = {
  variant?: "list" | "selection" | "no-results";
  query?: string;
  className?: string;
  onStartShipment?: () => void;
};

export default function ShipmentsEmptyState({
  variant = "list",
  query = "",
  className = "",
  onStartShipment,
}: ShipmentsEmptyStateProps) {
  if (variant === "selection") {
    return (
      <IllustrationEmptyState
        title="No Shipment Selected"
        description="Select a shipment to continue with Dockie!"
        className={className}
      />
    );
  }

  if (variant === "no-results") {
    const trimmed = query.trim();
    return (
      <IllustrationEmptyState
        title="No shipment found"
        description={
          trimmed
            ? `Nothing matches “${trimmed}”. Try a different VIN, make, model, or shipment number.`
            : "Nothing matches these filters. Try a different status or date."
        }
        className={className}
      />
    );
  }

  return (
    <IllustrationEmptyState
      title="You don't have any shipments yet"
      description="Shipments start in chat. Tell Dockie what you want to ship and we'll take it from there."
      actionLabel={onStartShipment ? "Start a shipment" : undefined}
      onAction={onStartShipment}
      className={className}
    />
  );
}
